import { type ReactElement, type SVGProps } from 'react';

export const Pin = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.44824C9.99116 6.44824 8.36268 8.11724 8.36268 10.176C8.36268 12.2348 9.99116 13.9038 12 13.9038C14.0088 13.9038 15.6373 12.2348 15.6373 10.176C15.6373 8.11724 14.0088 6.44824 12 6.44824ZM9.33841 10.176C9.33841 8.66952 10.53 7.44824 12 7.44824C13.4699 7.44824 14.6616 8.66952 14.6616 10.176C14.6616 11.6826 13.4699 12.9038 12 12.9038C10.53 12.9038 9.33841 11.6826 9.33841 10.176Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.35065 15.6221L7.35866 15.6139L11.9977 20.9981L16.9843 15.219C18.1265 13.8904 19 12.1727 19 10.1793C19 6.21467 15.8664 3 12 3C8.13364 3 5 6.21467 5 10.1793C5 12.1711 5.80328 13.7633 7.00692 15.2092L7.35065 15.6221ZM5.97573 10.1793C5.97573 6.76622 8.67324 4 12 4C15.3268 4 18.0243 6.76622 18.0243 10.1793C18.0243 11.8606 17.2881 13.3529 16.2522 14.5579L11.9982 19.4879L7.67667 14.4722C6.61207 13.1684 5.97573 11.8216 5.97573 10.1793Z"
        fill="currentColor"
      />
    </svg>
  );
};
